// --- Product Configuration Columns
import * as productsColumns from '../../../pages/Products/components/grid/config/columns';
// --- Clearance Memo Titles Configuration Columns
import * as titlesColumns from '../../../pages/ClearanceMemoTitles/components/grid/config/columns';
// --- Comment Modal Configuration Columns
import * as commentColumns from '../../CommentModals/ViewCommentsModal/config/columns';
// --- Shared Sections Configuration Columns
import * as sharedSectionsColumns from '../../../pages/SharedSections/components/grid/config/columns';
// --- Contacts Configuration Columns
import * as contactsColumns from '../../../pages/Contacts/components/grid/config/columns';
// --- Tags Configuration Columns
import * as tagsColumns from '../../../pages/Tags/components/grid/config/columns';
// --- Linked Products Configuration Columns
import * as linkedProductColumns from '../../../pages/SharedSections/components/modals/linked-products/grid/config/columns';

export const products = (
    onOpenCommentsModal,
     onOpenDetailsDrawer,
     onOpenLegalStatusModal,
     onOpenContractualPartiesModal,
     onOpenCopyToModal,
    onOpenVersionModal,
     onOpenDeleteModal,
     onOpenCreateModal,
     onOpenEditModal,
    onOpenViewModal,
) => ({
    default: [
        productsColumns.sid,
        productsColumns.productId,
        productsColumns.uuid,
        productsColumns.releaseDate,
        productsColumns.title,
        productsColumns.type,
        productsColumns.runTime,
        productsColumns.clearanceMemo(
            onOpenLegalStatusModal,
            onOpenContractualPartiesModal,
            onOpenCopyToModal,
            onOpenVersionModal,
            onOpenDeleteModal,
            onOpenCreateModal,
            onOpenEditModal,
            onOpenViewModal,
        ),
        productsColumns.comments(onOpenCommentsModal),
        productsColumns.rlLoadStatus,
        productsColumns.details(
            onOpenDetailsDrawer,
        ),
    ],
    limited: [
        productsColumns.sid,
        productsColumns.productId,
        productsColumns.uuid,
        productsColumns.releaseDate,
        productsColumns.title,
        productsColumns.type,
        productsColumns.runTime,
        productsColumns.comments(onOpenCommentsModal),
        productsColumns.rlLoadStatus,
        productsColumns.details(
            onOpenDetailsDrawer,
        ),
    ],
});

export const titles = (
    onOpenCMCommentsModal,
    onOpenCentFileModal,
     onOpenCopyrightModal,
    onOpenDeleteModal,
     onOpenCreateModal,
    onOpenEditModal,
    onOpenViewModal,
) => ({
    default: [
        titlesColumns.id,
        titlesColumns.title,
        titlesColumns.type,
        titlesColumns.status,
        titlesColumns.imported,
        titlesColumns.foxWprId,
        titlesColumns.foxId,
        titlesColumns.productId,
        titlesColumns.releaseDate,
        titlesColumns.legalStatus,
        titlesColumns.clearanceMemo(
            onOpenDeleteModal,
            onOpenCreateModal,
            onOpenEditModal,
            onOpenViewModal,
        ),
        titlesColumns.memo,
        titlesColumns.report,
        titlesColumns.comments(onOpenCMCommentsModal),
        titlesColumns.centFileNum(onOpenCentFileModal),
        titlesColumns.copyright(onOpenCopyrightModal),
        titlesColumns.created,
    ],
    limited: [
        titlesColumns.id,
        titlesColumns.title,
        titlesColumns.type,
        titlesColumns.status,
        titlesColumns.foxWprId,
        titlesColumns.foxId,
        titlesColumns.productId,
        titlesColumns.releaseDate,
        titlesColumns.legalStatus,
        titlesColumns.memo,
        titlesColumns.comments(onOpenCMCommentsModal),
        titlesColumns.copyright(
            onOpenCopyrightModal,
        ),
        titlesColumns.created,

    ]
});

export const comments = (onOpenAttachmentsModal) => ({
    default: [
        commentColumns.id,
        commentColumns.productId,
        commentColumns.financialTitleId,
        commentColumns.title,
        commentColumns.commentPreview,
        commentColumns.type,
        commentColumns.isPublic,
        commentColumns.attachments(onOpenAttachmentsModal),
        commentColumns.commenter,
        commentColumns.commented,
    ],
});

export const sharedSections = (
    onOpenSSModal,
    onOpenSSProductsModal,
) => ({
    default: [
        sharedSectionsColumns.id,
        sharedSectionsColumns.name,
        sharedSectionsColumns.type,
        sharedSectionsColumns.createdBy,
        sharedSectionsColumns.linked(onOpenSSProductsModal),
        sharedSectionsColumns.created,
        sharedSectionsColumns.edit(
            onOpenSSModal,
        ),
    ],
});

export const linkedProducts = (onOpenEditModal) => ({
    default: [
        linkedProductColumns.id,
        linkedProductColumns.title,
        linkedProductColumns.verified(onOpenEditModal),
        linkedProductColumns.added,
    ],
});

export const tags = () => ({
    default: [tagsColumns.id, tagsColumns.name, tagsColumns.createdBy, tagsColumns.createdAt],
});

export const contacts = () => ({
    default: [
        contactsColumns.id,
        contactsColumns.contact,
        contactsColumns.rightslineId,
        contactsColumns.formerlyKnownAs,
        contactsColumns.lobs,
        contactsColumns.canadianOrigination,
        contactsColumns.type,
        contactsColumns.alternateName,
        contactsColumns.alternateContact,
        contactsColumns.apolloId,
    ],
});
